import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
const { Text, Paragraph } = Typography;

export default function DeleteDialog({ open, onOpenChange, filesToDelete, onConfirm }) {
  const [observacion, setObservacion] = useState("");
  const [usuario, setUsuario] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const fileCount = filesToDelete.length;

  // ✅ Cargar usuario automáticamente cuando esté disponible
  useEffect(() => {
    if (user) {
      setUsuario(user.username || user.name || user); // ajusta según cómo se guarda en tu Redux
    }
  }, [user]);

  const handleConfirm = async () => {
    if (!usuario.trim()) return;

    setIsDeleting(true);
    try {
      await onConfirm(observacion, usuario);
      setObservacion("");
      onOpenChange(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => onOpenChange(false)}
      footer={[
        <Button key="cancel" onClick={() => onOpenChange(false)} disabled={isDeleting}>
          Cancelar
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={handleConfirm}
          disabled={!usuario.trim() || isDeleting}
          loading={isDeleting}
        >
          {isDeleting ? "Eliminando..." : "Eliminar"}
        </Button>,
      ]}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />
          Confirmar eliminación
        </div>
      }
    >
      <Paragraph>
        Estás a punto de eliminar <Text strong>{fileCount}</Text> archivo{fileCount !== 1 ? "s" : ""}. Esta acción no se puede deshacer.
      </Paragraph>

      <div style={{ marginBottom: 16 }}>
        <label>
          Usuario <Text style={{ color: "#ff4d4f" }}>*</Text>
        </label>
        <Input
          value={usuario}
          readOnly 
          style={{ marginTop: 4, backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
        />
      </div>

      <div>
        <label>Observación</label>
        <Input.TextArea
          placeholder="Motivo de la eliminación (opcional)"
          value={observacion}
          onChange={(e) => setObservacion(e.target.value)}
          rows={3}
          disabled={isDeleting}
          style={{ marginTop: 4 }}
        />
      </div>
    </Modal>
  );
}
